<template>
    <div>
         <con-tab @TwoClick="TwoClick"></con-tab>
       <!-- 政策详情 -->
        <PolicyNei ></PolicyNei>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import  PolicyNei from "./base/PolicyNei";
     export default {
        name: "policy",
        data(){
            return {
                
            }
        },
        created(){
            
        },
        methods:{
             TwoClick(item){
                //console.log(item);
                this.ConList = item
            },
        },
        components:{
            ConTab,
            PolicyNei
        }
    }
</script>

<style scoped>

</style>
